export const APIS = {
    auth: 'api/auth',
    login: 'api/auth/login',
    discoveryProcess: 'api/discovery-process',
    motivation: 'api/motivations',
    user:'api/user',
    challenges: 'api/challenges',
    conflicts: 'api/conflicts',
    responses: 'api/responses',
    data: 'api/data',
    chat: 'api/chat',
    structuredProcess: 'api/process'
}